import React from 'react';
import { Box, Typography } from '@mui/material';
import { SearchOff as SearchOffIcon } from '@mui/icons-material';

const SinResultados = () => {
  return (
    <Box textAlign="center" py={2}>
      <SearchOffIcon sx={{ fontSize: 40, color: 'text.secondary', mb: 1 }} />
      <Typography variant="body1" color="textSecondary">
        No hay pedidos con remito
      </Typography>
    </Box>
  );
};

export default SinResultados;